<template>
    <ies-form-field :field="field">
        <div class="checkbox">
            <input
                type="checkbox"
                v-model="isRoomRestricted"
                :disabled="field.disabled"
            >
        </div>

        <v-autocomplete
            v-if="isRoomRestricted"
            v-model="selectedRoomKeys"
            :items="rooms"
            item-text="name"
            item-value="key"
            :loading="loading"
            :disabled="field.disabled"
            multiple
            chips
            small-chips
            deletable-chips
            outlined
            dense
            class="mt-3"
        ></v-autocomplete>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-input-rate-type-room-restriction',
    props: ['field', 'page'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            isRoomRestricted: parseInt(this.field.value || this.field.oldValue) === 1,
            selectedRoomKeys: [],
            rooms: [],
            loading: false,
            hotelKey: null,
            rateTypeKey: null,
        };
    },
    computed: {
        submissionData: function () {
            return {
                isRoomRestricted: this.isRoomRestricted,
                roomKeys: this.selectedRoomKeys,
                rateTypeKey: this.rateTypeKey,
            };
        },
    },
    watch: {
        submissionData: {
            deep: true,
            handler: function (value) {
                this.field.value = value;
            },
        },

        isRoomRestricted: function (value) {
            if (value && this.rooms.length === 0 && this.hotelKey) {
                this.loadRooms();
            }
        },
    },
    methods: {
        setKeysFromUrl: function () {
            if (!this.page || !this.page.edit_url) {
                return;
            }

            let bits = this.page.edit_url.split('/');
            let urlBits = location.pathname.split('/').splice(1);

            bits.forEach(function (bit, index) {
                if (bit === '{Hotel.hotel_key}' || bit === '{RateType.hotel_key}') {
                    this.hotelKey = parseInt(urlBits[index]);
                }
                if (bit === '{RateType.rate_type_key}') {
                    this.rateTypeKey = parseInt(urlBits[index]);
                }
            }.bind(this));
        },

        loadRooms: function () {
            var rateTypeKey = this.rateTypeKey || 0;

            this.loading = true;

            axios.get('/api/rate-type-room-restrictions/' + this.hotelKey + '/' + rateTypeKey).then(function (response) {
                this.rooms = response.data.rooms;
                this.selectedRoomKeys = response.data.rooms
                    .filter(function (room) { return room.isRestricted; })
                    .map(function (room) { return room.key; });
            }.bind(this)).finally(function () {
                this.loading = false;
            }.bind(this));
        },
    },

    created: function () {
        this.setKeysFromUrl();
        this.field.value = this.submissionData;

        if (this.isRoomRestricted && this.hotelKey) {
            this.loadRooms();
        }
    },
};
</script>
